export default {
  palette: {
    primary: {
      main: "#4F818C",
      contrastText: "#fff",
    },
    secondary: {
      main: "#f7a692",
      contrastText: "#fff",
    },
    terceary: {
      main: "#B4D2D9",
      contrastText: "#fff",
    },
    success: {
      main: "#FFCD05",
      contrastText: "#000",
    },
  },

  //the object to be spread
  spreadThis: {
    typography: {
      useNextVariants: true,
    },
    form: {
      textAlign: "center",
      padding:20,
    },
    image: {
      margin: "20px auto 20px auto",
    },
    pageTitle: {
      margin: "10 auto 10 auto",
    },
    textField: {
      margin: 10,
    },
    textSearch: {
      margin: "0px 0px 10px 0px",
    },
    backgroundColorChange: {
      backgroundColor: "#B4D2D9",
    },
    autoComplete: {
      margin: "6px 10px 2px 10px",
    },
    button: {
      marginTop: 20,
      marginBottom: 14,
      position: "relative",
    },
    label: {
      textAlign: "left",
      margin: "20px 10px 10px 10px",
    },
    labelError: {
      textAlign: "left",
      color: "#f44336",
      margin: "4px 10px 10px 10px",
    },
    customError: {
      color: "red",
      fontSize: "0.8rem",
      marginTop: 10,
    },
    customSuccess: {
      color: "#00B200",
      fontSize: "1.0rem",
      marginTop: 10,
    },
    small: {
      fontSize: 16,
    },
    progress: {
      position: "absolute",
    },
    uploadImages: {
      margin: 10,
      fontSize: "16px",
    },
  },
};
